/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BrevoApiKeyDto } from '../model/brevoApiKeyDto';
import { TenantConfiguration } from '../model/tenantConfiguration';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ConfiguratorTenantConfigurationService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Obtenir la configuration pour un affilié
     * Cette requête permet de récupérer la configuration pour un affilié.&lt;br&gt;Une configuration est l&#39;ensemble des informations à propos d&#39;emailing et sa sécurisation.&lt;br&gt;En cas de succès, la réponse contient un objet TenantConfigurationDTO et un code 200 (OK).&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au datastore/tenant.&lt;br&gt;&lt;b&gt;Note :&lt;/b&gt; le paramètre &#39;affi&#39; est le code d&#39;affilié. On peut le récupérer dans le endpoint &#39;/api/datastores&#39;.
     * @param xDataStoreID X-DataStoreID
     * @param affi affi
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTenantConfigByAffiUsingGET(xDataStoreID: string, affi: string, observe?: 'body', reportProgress?: boolean): Observable<TenantConfiguration>;
    public getTenantConfigByAffiUsingGET(xDataStoreID: string, affi: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantConfiguration>>;
    public getTenantConfigByAffiUsingGET(xDataStoreID: string, affi: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantConfiguration>>;
    public getTenantConfigByAffiUsingGET(xDataStoreID: string, affi: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTenantConfigByAffiUsingGET.');
        }

        if (affi === null || affi === undefined) {
            throw new Error('Required parameter affi was null or undefined when calling getTenantConfigByAffiUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TenantConfiguration>(`${this.basePath}/api/tenant-config/${encodeURIComponent(String(affi))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir la configuration pour l&#39;affilié principal
     * Cette requête permet de récupérer la configuration pour l&#39;affilié principal.&lt;br&gt;Une configuration est l&#39;ensemble des informations à propos d&#39;emailing et sa sécurisation.
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTenantConfigUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<TenantConfiguration>;
    public getTenantConfigUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantConfiguration>>;
    public getTenantConfigUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantConfiguration>>;
    public getTenantConfigUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTenantConfigUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TenantConfiguration>(`${this.basePath}/api/tenant-config/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir la configuration clé API Brevo d'un partenaire
     * Retourne si une clé API Brevo est configurée pour le partenaire. La clé réelle n'est jamais exposée.
     */
    public getPartnerBrevoKeyUsingGET(xDataStoreID: string, partnerCode: string, observe?: 'body', reportProgress?: boolean): Observable<BrevoApiKeyDto>;
    public getPartnerBrevoKeyUsingGET(xDataStoreID: string, partnerCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrevoApiKeyDto>>;
    public getPartnerBrevoKeyUsingGET(xDataStoreID: string, partnerCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrevoApiKeyDto>>;
    public getPartnerBrevoKeyUsingGET(xDataStoreID: string, partnerCode: string, observe: any = 'body', reportProgress = false): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPartnerBrevoKeyUsingGET.');
        }
        if (partnerCode === null || partnerCode === undefined) {
            throw new Error('Required parameter partnerCode was null or undefined when calling getPartnerBrevoKeyUsingGET.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('X-DataStoreID', String(xDataStoreID));

        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(['application/json']);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<BrevoApiKeyDto>(
            `${this.basePath}/api/tenant-config/partner/${encodeURIComponent(String(partnerCode))}/brevo-key`,
            { withCredentials: this.configuration.withCredentials, headers, observe, reportProgress }
        );
    }

    /**
     * Enregistrer la clé API Brevo d'un partenaire
     * Chiffre et sauvegarde la clé API Brevo pour le partenaire donné.
     */
    public savePartnerBrevoKeyUsingPUT(xDataStoreID: string, partnerCode: string, dto: BrevoApiKeyDto, observe?: 'body', reportProgress?: boolean): Observable<BrevoApiKeyDto>;
    public savePartnerBrevoKeyUsingPUT(xDataStoreID: string, partnerCode: string, dto: BrevoApiKeyDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrevoApiKeyDto>>;
    public savePartnerBrevoKeyUsingPUT(xDataStoreID: string, partnerCode: string, dto: BrevoApiKeyDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrevoApiKeyDto>>;
    public savePartnerBrevoKeyUsingPUT(xDataStoreID: string, partnerCode: string, dto: BrevoApiKeyDto, observe: any = 'body', reportProgress = false): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling savePartnerBrevoKeyUsingPUT.');
        }
        if (partnerCode === null || partnerCode === undefined) {
            throw new Error('Required parameter partnerCode was null or undefined when calling savePartnerBrevoKeyUsingPUT.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('X-DataStoreID', String(xDataStoreID));

        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(['application/json']);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const contentTypeSelected = this.configuration.selectHeaderContentType(['application/json']);
        if (contentTypeSelected != undefined) {
            headers = headers.set('Content-Type', contentTypeSelected);
        }

        return this.httpClient.put<BrevoApiKeyDto>(
            `${this.basePath}/api/tenant-config/partner/${encodeURIComponent(String(partnerCode))}/brevo-key`,
            dto,
            { withCredentials: this.configuration.withCredentials, headers, observe, reportProgress }
        );
    }

    /** Supprimer la clé API Brevo d'un partenaire. */
    public deletePartnerBrevoKeyUsingDELETE(xDataStoreID: string, partnerCode: string, observe?: 'body', reportProgress?: boolean): Observable<BrevoApiKeyDto>;
    public deletePartnerBrevoKeyUsingDELETE(xDataStoreID: string, partnerCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BrevoApiKeyDto>>;
    public deletePartnerBrevoKeyUsingDELETE(xDataStoreID: string, partnerCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BrevoApiKeyDto>>;
    public deletePartnerBrevoKeyUsingDELETE(xDataStoreID: string, partnerCode: string, observe: any = 'body', reportProgress = false): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deletePartnerBrevoKeyUsingDELETE.');
        }
        if (partnerCode === null || partnerCode === undefined) {
            throw new Error('Required parameter partnerCode was null or undefined when calling deletePartnerBrevoKeyUsingDELETE.');
        }

        const headers = this.defaultHeaders.set('X-DataStoreID', String(xDataStoreID)).set('Accept', 'application/json');
        return this.httpClient.delete<BrevoApiKeyDto>(
            `${this.basePath}/api/tenant-config/partner/${encodeURIComponent(String(partnerCode))}/brevo-key`,
            { withCredentials: this.configuration.withCredentials, headers, observe, reportProgress }
        );
    }

    /**
     * Obtenir les CORS origins d'un partenaire
     */
    public getPartnerCorsOriginsUsingGET(xDataStoreID: string, partnerCode: string, observe?: 'body', reportProgress?: boolean): Observable<string[]>;
    public getPartnerCorsOriginsUsingGET(xDataStoreID: string, partnerCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string[]>>;
    public getPartnerCorsOriginsUsingGET(xDataStoreID: string, partnerCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string[]>>;
    public getPartnerCorsOriginsUsingGET(xDataStoreID: string, partnerCode: string, observe: any = 'body', reportProgress = false): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPartnerCorsOriginsUsingGET.');
        }
        if (partnerCode === null || partnerCode === undefined) {
            throw new Error('Required parameter partnerCode was null or undefined when calling getPartnerCorsOriginsUsingGET.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('X-DataStoreID', String(xDataStoreID));

        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(['application/json']);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<string[]>(
            `${this.basePath}/api/tenant-config/partner/${encodeURIComponent(String(partnerCode))}/cors-origins`,
            { withCredentials: this.configuration.withCredentials, headers, observe, reportProgress }
        );
    }

    /**
     * Enregistrer les CORS origins d'un partenaire
     */
    public savePartnerCorsOriginsUsingPUT(xDataStoreID: string, partnerCode: string, corsOrigins: string[], observe?: 'body', reportProgress?: boolean): Observable<string[]>;
    public savePartnerCorsOriginsUsingPUT(xDataStoreID: string, partnerCode: string, corsOrigins: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string[]>>;
    public savePartnerCorsOriginsUsingPUT(xDataStoreID: string, partnerCode: string, corsOrigins: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string[]>>;
    public savePartnerCorsOriginsUsingPUT(xDataStoreID: string, partnerCode: string, corsOrigins: string[], observe: any = 'body', reportProgress = false): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling savePartnerCorsOriginsUsingPUT.');
        }
        if (partnerCode === null || partnerCode === undefined) {
            throw new Error('Required parameter partnerCode was null or undefined when calling savePartnerCorsOriginsUsingPUT.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('X-DataStoreID', String(xDataStoreID));

        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(['application/json']);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const contentTypeSelected = this.configuration.selectHeaderContentType(['application/json']);
        if (contentTypeSelected != undefined) {
            headers = headers.set('Content-Type', contentTypeSelected);
        }

        return this.httpClient.put<string[]>(
            `${this.basePath}/api/tenant-config/partner/${encodeURIComponent(String(partnerCode))}/cors-origins`,
            corsOrigins,
            { withCredentials: this.configuration.withCredentials, headers, observe, reportProgress }
        );
    }

}
